import { serializeMoney } from '@/lib/adapters/common.adapter'
import type {
  CreatorCostsUpdateItem,
  CreatorCostsUpdatePayload,
  CreatorOneTimeEarning,
  CreatorOneTimeEarningRaw,
  CreatorOneTimePaymentForm,
  CreatorOneTimePaymentPayload,
  CreatorTrafficSourceCost,
} from '@/lib/types/creator-costs.types'

const toMajorAmount = (value: number | null | undefined): number | null =>
  value ? Number((value / 100).toFixed(2)) : (value ?? null)

const toPercentage = (value: number | null | undefined): number | null =>
  value ? Number((value * 100).toFixed(2)) : (value ?? null)

export const normalizeTrafficSourceCost = (raw: {
  source: number
  cpc: number | null
  cpa: number | null
  invoiceCpc?: number | null
  invoiceCpa?: number | null
}): CreatorTrafficSourceCost => {
  const cpa = toPercentage(raw.cpa)
  return {
    source: raw.source,
    cpc: toMajorAmount(raw.cpc),
    cpa,
    invoiceCpc: toMajorAmount(raw.invoiceCpc),
    invoiceCpa: toPercentage(raw.invoiceCpa),
    type: cpa ? 'CPA' : 'CPC',
  }
}

export const serializeCreatorCosts = (
  costs: CreatorTrafficSourceCost[],
  currencyCode: string,
): CreatorCostsUpdatePayload => {
  const trafficSourcesCosts: CreatorCostsUpdateItem[] = costs.map((cost) => ({
    source: cost.source,
    cpc: cost.cpc ? Math.round(cost.cpc * 100) : 0,
    cpc_v2: serializeMoney({ amount: cost.cpc ?? 0, currency: currencyCode }),
    cpa: cost.cpa ? Math.round(cost.cpa) / 100 : 0,
  }))

  return { traffic_sources_costs: trafficSourcesCosts }
}

export const normalizeCreatorOneTimeEarning = (
  raw: CreatorOneTimeEarningRaw,
): CreatorOneTimeEarning => ({
  amount: raw.user_earnings / 100,
  paymentDate: raw.payment_date,
  comment: raw.comment,
})

export const serializeOneTimePayment = (
  form: CreatorOneTimePaymentForm,
): CreatorOneTimePaymentPayload => ({
  user_earnings: Math.round(form.amount * 100),
  payment_date: form.paymentDate,
  comment: form.comment,
})
